import type {AddressRequestBody} from './AddressRequestBody';
import type {SelfEmployedInformationRequestBody} from './SelfEmployedInformationRequestBody';

export type ContactInformationRequestBody = {
  registrationNumber: string;
  vatNumber: string;
  companyName: string;
  fileNumber: string | null;
  address: AddressRequestBody;
  selfEmployedInformation?: SelfEmployedInformationRequestBody | null;
};
